import { c as _c } from "react-compiler-runtime";
import { createContext, useContext } from 'react';
import ReactDOM from 'react-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const NO_PROVIDER = Symbol('NO_PROVIDER');

// true on React 19+ (where ReactDOM.render was removed), false on React 18
let defaultPreference = typeof ReactDOM.render !== 'function';
const ReactCreateRootPreferenceContext = /*#__PURE__*/createContext(NO_PROVIDER);
export const ReactCreateRootPreferenceProvider = t0 => {
  const $ = _c(3);
  const {
    children,
    preferCreateRoot
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== preferCreateRoot) {
    t1 = /*#__PURE__*/_jsx(ReactCreateRootPreferenceContext.Provider, {
      value: preferCreateRoot,
      children: children
    });
    $[0] = children;
    $[1] = preferCreateRoot;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const usePrefersCreateRoot = () => {
  const contextValue = useContext(ReactCreateRootPreferenceContext);
  if (contextValue === NO_PROVIDER) {
    return defaultPreference;
  }
  return contextValue;
};
export const setDefaultCreateRootPreferenceForTesting = value => {
  defaultPreference = value;
};